import { render, staticRenderFns } from "./CollectionEdit.vue?vue&type=template&id=208efdac"
import script from "./CollectionEdit.vue?vue&type=script&lang=js"
export * from "./CollectionEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionEdit.vue?vue&type=style&index=0&id=208efdac&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports